import React from 'react';
import { string, shape, number } from 'prop-types';
import TDSIconTab from './TDSIconTab.js';
import CustomIconTab from './CustomIconTab.js';

var Tab = function Tab(props) {
  var iconName = props.iconName,
    customIcon = props.customIcon,
    iconImageUrl = props.iconImageUrl;
  if (customIcon !== null && customIcon !== void 0 && customIcon.name && iconImageUrl) {
    return /*#__PURE__*/React.createElement(CustomIconTab, props);
  }
  if (!iconName && !(customIcon !== null && customIcon !== void 0 && customIcon.name)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TDSIconTab, props);
};
Tab.propTypes = {
  iconName: string,
  iconImageUrl: string,
  customIcon: shape({
    name: string
  }),
  index: number.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  externalUrl: string.isRequired
};
Tab.defaultProps = {
  iconName: '',
  iconImageUrl: '',
  customIcon: {
    name: ''
  }
};

export { Tab as default };
